import type { DeleteLinkedItemsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteLinkedItemsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useUnlinkItems = createMutationHook({
  name: 'unlinkItems',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.linkedItem.unlink.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ Ids: ids }),
  invalidate: (trpc) => [
    // COI-889: router-level key — `linkedItemRisks` and
    // `linkedRisksByInternalAuditId` were reached by nothing.
    trpc.frontend.linkedItem.pathKey(),
    // COI-471 parity: Apollo twin also evicts every linkable entity family
    // (unlinking changes each side's linked-items tab / counts / scores).
    trpc.frontend.acceptance.pathKey(),
    trpc.frontend.action.pathKey(),
    trpc.frontend.appetite.pathKey(),
    trpc.frontend.control.pathKey(),
    trpc.frontend.controlGroup.pathKey(),
    trpc.frontend.document.pathKey(),
    trpc.frontend.indicator.pathKey(),
    trpc.frontend.internalAuditEntity.pathKey(),
    trpc.frontend.issue.pathKey(),
    trpc.frontend.obligation.pathKey(),
    trpc.frontend.obligationChange.pathKey(),
    trpc.frontend.risk.pathKey(),
    // COI-889: unlinking deletes entity `_parent` rows (linked-item-repo),
    // whose forward triggers maintain the `node_ancestor` table behind
    // `ancestor_contributor_view` — the ribbon's inherited-ownership filters.
    trpc.frontend.myItems.pathKey(),
  ],
  // Consumers ignore the payload — echo the unlinked ids.
  mapResponse: (_result, ids: string[]): DeleteLinkedItemsMutation => ({
    unlinkItems: {
      __typename: 'UnlinkItemsOutput',
      Ids: ids,
    },
  }),
  graphqlDocument: DeleteLinkedItemsDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  evictFields: [
    'linked_item',
    'control',
    'control_group',
    'action',
    'appetite',
    'issue',
    'document',
    'obligation',
    'obligation_change',
    'risk',
    'acceptance',
    'indicator',
    'internal_audit_entity',
    'internal_audit_entity_aggregate',
    'risk_score',
  ],
});
